// src/components/ui/drawer.jsx
import React from "react";
import ReactDOM from "react-dom";

export function Drawer({ open, onClose, title, children }) {
  if (!open) return null; // ne renderuj kad je zatvoren

  return (
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-black/40 z-50"
        onClick={onClose}
        aria-hidden="true"
      />

      {/* Panel */}
      <div className="fixed inset-y-0 right-0 z-50 flex">
        <div
          role="dialog"
          aria-modal="true"
          className="
            h-full bg-white dark:bg-neutral-900 shadow-2xl
            transition-transform duration-200 ease-out
            w-[92vw] max-w-[92vw] sm:w-[420px] sm:max-w-[420px]
            sm:rounded-l-xl overscroll-contain
          "
          style={{ transform: "translateX(0)" }}
          onClick={e => e.stopPropagation()}
        >
          {/* Header ostaje vidljiv pri skrolu */}
          <div className="
              sticky top-0 z-10 bg-white/95 dark:bg-neutral-900/95
              backdrop-blur border-b border-gray-200 dark:border-neutral-800
              flex items-center justify-between p-4
            ">
            <h3 className="text-lg font-semibold pr-2">{title}</h3>
            <button
              onClick={onClose}
              className="h-8 px-3 rounded border hover:bg-gray-50 dark:hover:bg-neutral-800"
            >
              Close
            </button>
          </div>

          {/* Sadržaj skroluje */}
          <div className="p-4 overflow-y-auto h-[calc(100%-56px)]">
            {children}
          </div>
        </div>
      </div>
    </>
  );
}
